import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import Topbar from "./Topbar";
import { UIContext } from "../UIContext";


const Layout = (props) => {

  const { ui } = useContext(UIContext);

  return (
    <>
      <div style={{backgroundColor:'#475B65', padding:'3px'}}>
        {ui.fullScreen ?
          null :
          <Topbar isAuth={props.isAuth} userInfo={props.userInfo} logoutHandler={props.logoutHandler} />
        }

        <div>
          <Outlet />
        </div>

      </div>
    </>
  );
};

export default Layout;
